import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import { APPLICATION_GLOBAL_SLUG, URLS, replaceNbsp } from "src/_config";
import parse from "html-react-parser";
import NotifyMeModal from "../events/modal/notifiyMeModal";

type LandingInfo = {
  using_image?: number;
  show_logo?: number;
  description?: string;
  is_pick_open_notify?: number;
  background_image?: { original?: string };
};
type GameDetails = {
  is_show_landing_page?: number;
  landing_info?: LandingInfo;
  redirect_automatically?: number;
};

export default function LandingPage() {
  const eventApi = useEventApi();
  const history = useHistory();
  const [gameDetails, setGameDetails] = useState<GameDetails | null>(null);
  const [showNotifyMeModal, setShowNotifyMeModal] = useState<boolean>(false);
  const [previousBackground, setPreviousBackground] = useState<string>("");

  const openNotifyMeModal = () => {
    setShowNotifyMeModal(true);
  };

  const closeNotifyMeModal = () => {
    setShowNotifyMeModal(false);
  };

  const getGameDetails = () => {
    const params = {
      slug: APPLICATION_GLOBAL_SLUG,
    };
    eventApi.callGetGameDetails(
      params,
      (_message: string, resp: unknown) => {
        console.log({ resp });
        if (resp && typeof resp === "object" && (resp as GameDetails).is_show_landing_page == 0) {
          history.push(URLS.HOME);
        }
        setGameDetails(resp as GameDetails);
        if (resp && typeof resp === "object" && (resp as GameDetails).is_show_landing_page == 1 && (resp as GameDetails).landing_info) {
          const landingInfo = (resp as GameDetails).landing_info;
          if (landingInfo?.using_image == 1) {
            const bodyTag = document.getElementsByTagName("body");
            if (bodyTag.length) {
              setPreviousBackground(bodyTag[0].style.background);
              console.log(landingInfo?.background_image?.original);
              bodyTag[0].style.backgroundImage = `url(${landingInfo?.background_image?.original})`;
              bodyTag[0].style.backgroundSize = "contain";
              bodyTag[0].style.backgroundRepeat = "no-repeat";
              bodyTag[0].style.backgroundPosition = "50% 50%";
            }
          }
        }
      },
      (_message: string) => {
        // no-op
      }
    );
  };

  useEffect(() => {
    getGameDetails();
    return () => {
      const bodyTag = document.getElementsByTagName("body");
      if (bodyTag.length) {
        bodyTag[0].style.background = previousBackground;
      }
    };
  }, []);

  return (
    <React.Fragment>
      {gameDetails?.landing_info?.using_image == 0 && (
        <>
          <div className="logo-wrap" style={{ minHeight: "200px" }}>
            {gameDetails?.landing_info?.show_logo == 1 && (
              <img src="/images/logo.png" alt="Logo" className="medium-logo" />
            )}
          </div>
          {gameDetails?.landing_info?.description && (
            <div style={{ color: "white", padding: "25px" }}>
              {parse(replaceNbsp(gameDetails?.landing_info?.description))}
            </div>
          )}
        </>
      )}
      {gameDetails?.landing_info?.is_pick_open_notify == 1 && gameDetails?.redirect_automatically != 1 && (
        <div className="notifiy-wrap">
          <p className="notify-text text-white">Get notified when picks open!!</p>
          <button
            // className="rkmd-btn btn-lg btn-orange ripple-effect w-100 mt-3 notify-btn"
            className="rkmd-btn btn-lg btn-orange ripple-effect w-100 notify-btn"
            onClick={openNotifyMeModal}
          >
            Notify me
          </button>
        </div>
      )}
      <NotifyMeModal onClose={closeNotifyMeModal} shouldShow={showNotifyMeModal} />
    </React.Fragment>
  );
}
